import { useEffect } from "react";
import { Button } from "@/components/ui/Button";

const PAGE_TITLE = "Page not found | Accent Productions";

/**
 * Catch-all 404 — ported from web/src/app/not-found.tsx (#144).
 *
 * Registered as the `path: "*"` route inside RootLayout so unmatched public
 * URLs get the branded page (with Header/Footer chrome) instead of React
 * Router's default developer error boundary.
 */
export default function NotFoundPage(): React.JSX.Element {
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center">
        <h1 className="text-7xl md:text-8xl font-bold tracking-tight text-gray-900 mb-2">
          404<span className="text-orange-600">.</span>
        </h1>
        <p className="text-lg text-gray-700 mb-6">
          This page doesn&apos;t exist.
        </p>
        <div className="flex gap-3 justify-center">
          <Button href="/" size="sm">
            Go home
          </Button>
          <Button href="/contact" variant="secondary" size="sm">
            Contact us
          </Button>
        </div>
      </div>
    </div>
  );
}
